import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result, UseCase } from '@digibricks/domains';
export var CANCEL_HEADING_USE_CASE = 'CANCEL_HEADING_USE_CASE';
export var CancelHeadingUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CancelHeadingUseCase, _UseCase);

  var _super = _createSuper(CancelHeadingUseCase);

  function CancelHeadingUseCase() {
    _classCallCheck(this, CancelHeadingUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(CancelHeadingUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var revertedHeading, newHeading, headings, canceledHeadingId, previousHeading, nextHeading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                revertedHeading = input.revertedHeading, newHeading = input.newHeading, headings = input.headings; // Case 1: Revert an existing heading to its original state

                if (!revertedHeading) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok({
                  canceledHeading: revertedHeading.clone()
                }));

              case 3:
                if (!newHeading) {
                  _context.next = 11;
                  break;
                }

                // Mark heading as deactivated for removal
                newHeading.deActivate();
                canceledHeadingId = newHeading.id.toString();
                previousHeading = headings === null || headings === void 0 ? void 0 : headings.find(function (heading) {
                  return heading.nextHeadingId === canceledHeadingId;
                });
                nextHeading = headings === null || headings === void 0 ? void 0 : headings.find(function (heading) {
                  return heading.previousHeadingId === canceledHeadingId;
                });

                if (previousHeading) {
                  previousHeading.updateNextHeadingId(newHeading.nextHeadingId);
                }

                if (nextHeading) {
                  nextHeading.updatePreviousHeadingId(newHeading.previousHeadingId);
                }

                return _context.abrupt("return", Result.ok({
                  canceledHeading: newHeading.clone(),
                  previousHeading: previousHeading === null || previousHeading === void 0 ? void 0 : previousHeading.clone(),
                  nextHeading: nextHeading === null || nextHeading === void 0 ? void 0 : nextHeading.clone()
                }));

              case 11:
                return _context.abrupt("return", new BadInputError('No valid input provided for cancel heading'));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CancelHeadingUseCase;
}(UseCase);